import ComingSoon from '@/components/ComingSoon';

const ChannelManager = () => {
    return (
        <ComingSoon />
    );
};

export default ChannelManager;
